export default "__VITE_ASSET__jTfCpsLw__"